import { render, staticRenderFns } from "./EventDetailPage.vue?vue&type=template&id=64cd3a94&scoped=true&"
import script from "./EventDetailPage.vue?vue&type=script&lang=ts&"
export * from "./EventDetailPage.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailPage.vue?vue&type=style&index=0&id=64cd3a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd3a94",
  null
  
)

export default component.exports